import apiClient from './axios';

/**
 * 회원 정보 (관리자용)
 */
export interface AdminMemberInfo {
  memberId: string;
  nickname: string;
  createdAt: string; // ISO 8601 형식
}

/**
 * Discord Bot 상태 응답
 */
export interface DiscordBotResponse {
  message: string; // "봇on" or "봇off"
}

/**
 * 관리자 API
 */

/**
 * 전체 회원 목록 조회
 */
export const getAllMembers = async (): Promise<AdminMemberInfo[]> => {
  const response = await apiClient.get<AdminMemberInfo[]>('/api/members');
  return response.data;
};

/**
 * 가입 승인 대기 회원 목록 조회
 */
export const getPendingMembers = async (): Promise<AdminMemberInfo[]> => {
  const response = await apiClient.get<AdminMemberInfo[]>('/api/members/pending');
  return response.data;
};

/**
 * 회원 승인
 */
export const approveMember = async (memberId: string): Promise<void> => {
  await apiClient.put(`/api/members/${memberId}/approve`);
};

/**
 * 회원 삭제 (승인 거부 또는 강제 탈퇴)
 */
export const deleteMember = async (memberId: string): Promise<void> => {
  await apiClient.delete(`/api/members/${memberId}`);
};

/**
 * Discord Bot on/off 토글
 */
export const toggleDiscordBot = async (): Promise<string> => {
  const response = await apiClient.get<string>('/discordBot');
  return response.data; // "봇on" or "봇off"
};
